import React from "react";

export default function ToyotaSienna({ activeSubTab, handleSubTabClick, carLabel }) {
  const subTabs = [
    { id: "driving", label: "Driving" },
    { id: "features", label: "Features" },
    { id: "faq", label: "FAQ" },
  ];

  return (
    <div className="space-y-8">
      {/* Header */}
      <h1 className="text-3xl font-extrabold text-gray-900 pl-3 border-l-4 border-blue-600">
        {carLabel}
      </h1>

      {/* Sub-tabs (desktop only) */}
      <div className="hidden md:flex gap-2 flex-wrap">
        {subTabs.map((sub) => (
          <button
            key={sub.id}
            onClick={() => handleSubTabClick("sienna", sub.id)}
            className={`px-3 py-2 rounded-md text-sm font-medium transition ${activeSubTab === sub.id ||
              (!activeSubTab && sub.id === "driving")
              ? "bg-blue-600 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}
          >
            {sub.label}
          </button>
        ))}
      </div>

      {/* Driving */}
      {(!activeSubTab || activeSubTab === "driving") && (
        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold mb-2">🚗 Hybrid Driving</h2>
            <p className="text-gray-700">
              The Sienna is a hybrid — no plugging in required. It automatically
              switches between gas and electric for efficiency.
            </p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold mb-2">⛽ Fuel Economy</h2>
            <p className="text-gray-700">
              Expect ~36 MPG combined. Use Eco mode for maximum efficiency.
            </p>
          </div>
        </div>
      )}

      {/* Features */}
      {activeSubTab === "features" && (
        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold mb-2">👨‍👩‍👧‍👦 Family Comfort</h2>
            <p className="text-gray-700">
              Sliding doors, spacious 3‑row seating, and rear climate controls
              make it family‑friendly.
            </p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold mb-2">📱 Tech</h2>
            <p className="text-gray-700">
              Apple CarPlay, Android Auto, and multiple USB ports keep everyone
              connected.
            </p>
          </div>
        </div>
      )}

      {/* FAQ */}
      {activeSubTab === "faq" && (
        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-2xl font-bold mb-4">❓ Toyota Sienna FAQ</h2>
            <div className="divide-y divide-gray-200">
              <div className="py-3">
                <p className="font-semibold">What fuel does it take?</p>
                <p className="text-gray-700">Regular unleaded gasoline.</p>
              </div>
              <div className="py-3">
                <p className="font-semibold">Does it need to be plugged in?</p>
                <p className="text-gray-700">No — it’s a self‑charging hybrid.</p>
              </div>
              <div className="py-3">
                <p className="font-semibold">How do I fold the seats?</p>
                <p className="text-gray-700">
                  The third row folds flat into the floor for extra cargo space.
                  The second row can slide forward for easier access, but does
                  not fully stow.
                </p>
              </div>
              <div className="py-3">
                <p className="font-semibold">Does it have Apple CarPlay?</p>
                <p className="text-gray-700">
                  Yes — Apple CarPlay and Android Auto are standard on the 2022
                  Sienna.
                </p>
              </div>
              <div className="py-3">
                <p className="font-semibold">What’s the fuel economy?</p>
                <p className="text-gray-700">
                  Around 36 MPG combined (city and highway), thanks to the
                  hybrid system.
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}